import React from "react";

const Header = () => {
  return (
    <div className="header">
      <h2>Media Downloader </h2>
      <h4>Download videos and pictures from over a 100 sites</h4>
    </div>
  );
};
export default Header;
